import { combineReducers } from 'redux';
import applicationReducer from './application/applicationReducer';
import userReducer from './user/userReducer';
import saleordersReducer from './saleorders/saleordersReducer';
import mypaymentsReducer from './mypayments/mypaymentsReducer';
import paymentplanReducer from './paymentplan/paymentplanReducer';
import accountReducer from './account/accountReducer';
import postReducer from './posts/postReducer';
import quotastopayReducer from './quotastopay/quotastopayReducer';
import paymentmethodReducer from './paymentmethod/paymentmethodReducer';
import paymentReducer from './payment/paymentReducer';

import { USER_LOGOUT } from 'reducers/application/actionConst';

const appReducer = combineReducers({
    application: applicationReducer,
    user: userReducer,
    saleorders: saleordersReducer,
    mypayments: mypaymentsReducer,
    paymentplan: paymentplanReducer,
    account: accountReducer,
    posts: postReducer,
    quotasToPay: quotastopayReducer,
    paymentMethods: paymentmethodReducer,
    payment: paymentReducer
});

const rootReducer = (state, action) => {
    if (action.type === USER_LOGOUT) {
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js